import { ApolloError } from "@apollo/client";
import { ErrorMessage, Field, useField, useFormikContext } from "formik";
import React from "react";
import { CloseButton, Form, FormControlProps } from "react-bootstrap";
import { useGraphqlErrors } from "../../../hooks/useGraphqlErrors";

interface IDomainInputProps extends FormControlProps {
  errorApollo?: ApolloError;
  label: string;
  placeholder: string;
  className?: string;
}
export default function DomainInput({
  errorApollo,
  label,
  placeholder,
  className,
  ...props
}: IDomainInputProps) {
  const { getErrorMessages } = useGraphqlErrors();
  const [field] = useField(props.name);
  const { setFieldValue } = useFormikContext();

  return (
    <>
      <Form.Group
        controlId="formdomain"
        className="w-100 position-relative overflow-hidden"
      >
        <div
          className="position-absolute pe-none text-nowrap text-info"
          style={{ left: 13, top: 8, fontSize: 12 }}
        >
          {label}
        </div>

        <span
          className="position-absolute pe-none text-nowrap"
          style={{ zIndex: 1, left: 13, top: 25 }}
        >
          <span className="fw-bold">https://</span>
          {!field.value.length && (
            <span className="text-secondary">{placeholder}</span>
          )}
        </span>
        <Field
          as={Form.Control}
          type="text"
          {...field}
          {...props}
          className={`pt-4 pb-1 domain-input bg-transparent position-relative${className ? ` ${className}` : ""}`}
        />
        {!!field.value.length && (
          <div
            className="position-absolute top-0 end-0 mt-3 w-auto me-3"
            style={{ zIndex: 2 }}
          >
            <CloseButton
              style={{ width: 8 }}
              onClick={() => setFieldValue(field.name, "")}
            />
          </div>
        )}
      </Form.Group>
      <ErrorMessage
        name={field.name}
        render={(msg) => (
          <div className="invalid-feedback text-start d-block">{msg}</div>
        )}
      />
      {errorApollo && (
        <div className="invalid-feedback text-start d-block">
          {getErrorMessages(errorApollo)[0]}
        </div>
      )}
    </>
  );
}
